export default class {
  constructor() {
    this.subs = {};
  }
  // 注册
  on(event, cb) {
    (this.subs[event] || (this.subs[event] = [])).push(cb);
  }
  // 解除
  off(event, offCb) {
    if (this.subs[event]) {
      const index = this.subs[event].findIndex(cb => cb === offCb);
      this.subs[event].splice(index, 1);
      if (!this.subs[event].length) delete this.subs[event];
    }
  }
  // 触发
  trigger(event, ...args) {
    this.subs[event] && this.subs[event].forEach(cb => cb(...args));
  }
  // 一次调用
  once(event, onceCb) {
    const cb = (...args) => {
      onceCb(...args);
      this.off(event, onceCb);
    };
    this.on(event, cb);
  }
}
